import { Component, effect, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet, Router } from '@angular/router';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
  private readonly router = inject(Router);
  private readonly titleService = inject(Title);
  public title = 'nrg-web';

  constructor() {
    this.titleService.setTitle('NRG metrics' + (environment.environmentLabel ? ` (${environment.environmentLabel.toLowerCase()})` : ''));

    effect(async () => {
      if (this.keycloakSignal().type === KeycloakEventType.AuthRefreshError) {
        await this.router.navigate(['/', 'logout']);
      }
    });
  }
}
